import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { addDataLayer } from '../lib/GoogleTagManager';

const Wrapper = styled(RouterLink)`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: 600;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border:none;
  background-color: transparent;

  ${({ theme, rightchevron }) => (rightchevron === 'true' && `
    font-size:1.1rem;
    padding: ${theme.spacing}px 0;
    margin: -${theme.spacing}px 0;

    .text {
      margin-right: .5em;
    }
  `)}


  svg {
    font-size:0.8em;

  }
`;

const TextLink = ({
  className, children, props, rightChevron, component, dataLayer, onClick,
}) => {
  const classes = ['TextLink', className];

  const handleClick = (e) => {
    addDataLayer(dataLayer);
    if (onClick) onClick(e);
  };

  return (
    <Wrapper
      onClick={handleClick}
      as={component}
      className={classes.filter((c) => !!c).join(' ')}
      {...props}
      rightchevron={rightChevron.toString()}
    >
      <span className="text">
        {children}
      </span>
      {rightChevron && <FontAwesomeIcon icon={faChevronRight} />}
    </Wrapper>
  );
};

TextLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  props: PropTypes.shape({}),
  rightChevron: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  dataLayer: PropTypes.shape({
    action: PropTypes.string,
    label: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

TextLink.defaultProps = {
  className: null,
  props: null,
  rightChevron: false,
  component: RouterLink,
  dataLayer: null,
  onClick: null,
};

export default TextLink;
